<template>
  <div class="panel-contanier">
    <!-- <div v-if="showLine" class="line"></div> -->
    <el-divider content-position="left">
      <slot name="header">
        <span>{{ title }}</span>
      </slot>
    </el-divider>
    <div class="opt">
      <slot name="opt"> </slot>
    </div>
    <!-- <div class="top-cotent" :style="topContentSty">
      <div class="top" :style="topSty">
        <svg-icon v-if="showIcon" iconClass="panel-icon1" className="icon" />
      </div>
    </div> -->
    <div class="panel-content" :style="panelContentSty">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: 'auto'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showLine: {
      type: Boolean,
      default: false
    },
    topSty: {
      type: Object
    },
    panelContentSty: {
      type: Object
    },
    topContentSty: {
      type: Object
    }
  }
}
</script>

<style lang="less" scoped>
.panel-contanier {
  position: relative;
  width: calc(100% - 64px);
  margin: 0 auto;
  height: auto;
  &:deep(.el-divider__text) {
    font-size: 16px;
    font-weight: bold;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #f7f7f7;
    margin-bottom: 20px;
  }
  .top-cotent {
    width: 100%;
    height: 40px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    position: relative;
  }
  .top {
    min-width: 160px;
    width: auto;
    height: 40px;
    background: #304156;
    border-radius: 4px 20px 20px 4px;
    padding: 0 0 0 17px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    z-index: 1;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    .icon {
      font-size: 24px;
      margin-right: 8px;
    }
  }
  .opt {
    z-index: 1;
     position: absolute;
    right: 0;
    top: -20px;
  }
  .panel-content {
    width: 100%;
    height: auto;
  }
}
</style>
